export default __webpack_public_path__ + "static/media/selectcourse.45b80bef.svg";